import { fetchFromOldApi } from '~/services/Http';

export type CreateUserAccountSubmission = {
  fLoginEmpId: number;
  fLoginUserFirstname: string;
  fLoginUserLastname: string;
  fLoginUsername: string;
  fLoginUserRoles: string[];
  fLoginUserLanguage: string;
  fLoginUserIsExternal?: boolean;
};

export type NewUserAccountDetails = {
  fLoginUsername: string;
  fLoginPassword: string;
  fLoginIsExternal?: boolean;
};

export type NewUserSendAccountDetails = {
  fLoginEmpId: number;
  fLoginUsername: string;
  fLoginPassword: string;
  fAlternateEmail?: string;
  fSmsPhoneNumber?: string;
};

export const createUserAccount = (
  data: CreateUserAccountSubmission,
): Promise<NewUserAccountDetails> => {
  return fetchFromOldApi('/form/user', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then((r) => r.json());
};

export const sendUserAccountDetails = (
  data: NewUserSendAccountDetails,
): Promise<NewUserAccountDetails> => {
  return fetchFromOldApi('/json/user/welcome', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then((r) => r.json());
};
